import {
  SELECT_PROJECT,
  ROLLBACK_PROJECT,
} from 'store/services/project/actionTypes';
import * as types from './actionTypes';
import initialState from './initialState';

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.START_CHAT_REQUEST:
      return {
        ...state,
        isLoading: true,
        isOpen: true,
        error: '',
        data: {
          ...state.data,
          id: action.payload.id,
          thread: action.payload.thread,
        },
      };
    case types.SAVE_USER_RESPONSE:
    case types.SAVE_BOT_RESPONSE:
      return {
        ...state,
        data: {
          ...state.data,
          thread: [...state.data.thread, action.payload.message],
        },
      };
    case types.SEND_MESSAGE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    case types.START_CHAT_SUCCESS:
    case types.SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case types.START_CHAT_ERROR:
    case types.SEND_MESSAGE_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case types.STOP_CHAT_REQUEST:
      return {
        ...state,
        isLoading: false,
        error: '',
        isOpen: false,
        data: {
          id: '',
          thread: [],
        },
      };
    case types.RESTART_CHAT:
      return {
        ...state,
        data: {
          ...state.data,
          thread: action.payload.thread,
        },
      };
    case types.TOGGLE_MINIMIZE_CHAT_REQUEST:
      return {
        ...state,
        isOpen: action.payload.isOpen,
      };
    case SELECT_PROJECT:
    case ROLLBACK_PROJECT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
